export const ENDPOINTS = {
  AUTH: {
    LOGIN: "api/v1/outinservice/login",
    LOGOUT: "api/v1/outinservice/logout",
  },
  USERS: {
    GET: "api/v1/outinservice/getallusers",
    DELETE: "api/v1/outinservice/deleteuser",
    ADD: "api/v1/outinservice/signup",
  },
  CONGREGATIONS: {
    GET: "api/v1/outinservice/getallcongregations",
    ADD: "api/v1/outinservice/addcongregation",
    UPDATE: "api/v1/outinservice/updatcongregation",
    DELETE: "api/v1/outinservice/deletecongregation",
    GETSTATE: "api/v1/outinservice/getstates",
    GETCITIES: "api/v1/outinservice/getcitiesbystate",
    REQUEST_STATUS: "api/v1/outinservice/updatecongregationrequeststatus",
    GET_CONGRIGATION: "api/v1/outinservice/getcongregationbystateandcity",
    GET_REQUESTED_CONGREGATION: "api/v1/outinservice/getcongregationrequests",
  },
  CMS: {
    PRIVACY_POLICY:
      "api/v1/outinservice/createupdatecmspagedata/privacy-policy",
    TERM_AND_CONDITION:
      "api/v1/outinservice/createupdatecmspagedata/term-and-condition",
    GET_PRIVACY_POLICY: "api/v1/outinservice/getcmspagedata/privacy-policy",
    GET_TERM_AND_CONDITION:
      "api/v1/outinservice/getcmspagedata/term-and-condition",
  },
};
